import { Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import SquareFilled from '@mui/icons-material/Square';
import SquareOutline from '@mui/icons-material/SquareOutlined';
import Circle from '@mui/icons-material/Circle';
import CircleOutline from '@mui/icons-material/CircleOutlined';

export function Legend(props) {
  const { layer } = props;

  return (
    <Box
      sx={{
        right: 8,
        width: '100%',
        bgcolor: 'white',
        pointerEvents: 'auto',
      }}
    >
      <Box
        sx={{
          fontSize: 15,
          bgcolor: 'white',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Box sx={{ flex: 1, bgcolor: 'white' }}>
          <List
            sx={{
              position: 'relative',
              overflow: 'auto',
              columnCount: Object.entries(layer.legend).length > 8 ? 2 : 1,
              p: 0,
              '& .MuiListItemText-root': { m: 0 },
            }}
          >
            {Object.entries(layer.legend || {})
              .sort((a, b) => a[0] - b[0])
              .map(buildLegendItem)}
          </List>
        </Box>
      </Box>
    </Box>
  );

  function buildLegendItem([key, config]) {
    return (
      <ListItem sx={{ pt: 0, pb: 0, mt: 0, mb: 0 }} key={key}>
        <ListItemIcon sx={{ minWidth: 2, mr: 0.5 }}>
          {getColorSwatch(config)}
        </ListItemIcon>
        <ListItemText primary={config.label} />
      </ListItem>
    );
  }

  function getColorSwatch(config) {
    if (config.size) {
      return (
        <Box sx={{ position: 'relative' }}>
          <Circle sx={{ color: config.color }} />
          <CircleOutline
            sx={{ position: 'absolute', top: 0, left: 0, color: config.stroke }}
          />
        </Box>
      );
    }

    if (!config.color) return <SquareOutline sx={{ color: config.stroke }} />;
    return <SquareFilled sx={{ color: config.color }} />;
  }
}
